var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { localizeUrl } from '../../core/helpers/url-helper';
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Footer.prototype.render = function () {
        return (React.createElement("footer", { className: "c-footer" },
            React.createElement("div", { className: "l-container" },
                React.createElement("div", { className: "c-footer__content" },
                    React.createElement("div", { className: "c-footer__top" },
                        React.createElement("div", { className: "c-footer__language-dropdown" }),
                        React.createElement("div", { className: "c-footer__products" },
                            React.createElement("h1", null, this.props.t('footer.products.title')),
                            React.createElement("ul", { className: "c-footer__navigation" }, window.App.products.map(function (item, key) { return (React.createElement("li", { key: key },
                                React.createElement(Link, { to: localizeUrl("/products/" + item.slug) }, item.translations[window.App.locale.locale].name))); }))),
                        React.createElement("div", { className: "c-footer__fraimsy" },
                            React.createElement("h1", null, this.props.t('footer.fraimsy.title')),
                            React.createElement("div", { className: "c-footer__fraimsy__columns" },
                                React.createElement("ul", { className: "c-footer__navigation" },
                                    React.createElement("li", null,
                                        React.createElement(Link, { to: localizeUrl(this.props.t('route.about_us.slug')) }, this.props.t('navigation.links.about_us.title'))),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: this.props.t('navigation.links.pricing_and_shipping.url'), target: "_blank" }, this.props.t('navigation.links.pricing_and_shipping.title'))),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: this.props.t('navigation.links.help_center.url'), target: "_blank" }, this.props.t('navigation.links.help_center.title')))),
                                React.createElement("ul", { className: "c-footer__navigation" },
                                    React.createElement("li", null,
                                        React.createElement(Link, { to: localizeUrl(this.props.t('route.cookie_policy.slug')) }, this.props.t('navigation.links.cookie_policy.title'))),
                                    React.createElement("li", null,
                                        React.createElement(Link, { to: localizeUrl(this.props.t('route.terms_and_conditions.slug')) }, this.props.t('navigation.links.terms_and_conditions.title'))),
                                    React.createElement("li", null,
                                        React.createElement(Link, { to: localizeUrl(this.props.t('route.privacy_policy.slug')) }, this.props.t('navigation.links.privacy_policy.title')))))),
                        React.createElement("div", { className: "c-footer__social" },
                            React.createElement("h1", null, this.props.t('footer.social.title')),
                            React.createElement("ul", { className: "c-footer__social__links" },
                                React.createElement("li", null,
                                    React.createElement("a", { href: "https://www.facebook.com/fraimsy", target: "_blank", className: "c-social-icon" },
                                        React.createElement("i", { className: "icon-facebook" }))),
                                React.createElement("li", null,
                                    React.createElement("a", { href: "https://www.instagram.com/fraimsy/", target: "_blank", className: "c-social-icon" },
                                        React.createElement("i", { className: "icon-instagram" })))))),
                    React.createElement("div", { className: "c-footer__copyright" }, this.props.t('footer.copyright.text'))))));
    };
    Footer.prototype.renderAuthDependentLinks = function () {
        return null;
    };
    return Footer;
}(React.Component));
export default withTranslation()(Footer);
